'use client';
import Video from '@/app/_components/ui/icons/Video.svg';
import Heart from '@/app/_components/ui/icons/Heart.svg';
import SmallPdf from '@/app/_components/ui/icons/SmallPdf.svg';
import Compare from '@/app/_components/ui/icons/Compare.svg';
import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';
import { useUpdateFavorite } from '@/app/_hooks/useFavorite';
import { useRouter } from 'next/navigation';
import ScrollToSection from '../share/ScrollToSection';

export default function ProductGalleryToolbar({
  productId,
  userToken,
  catalog,
  video,
  compare,
}) {
  const router = useRouter();
  const [sucessLabel, setSucessLabel] = useState(false);
  const updateFavoritList = useUpdateFavorite(userToken);
  const pathname = usePathname();

  const addProductToFavoritList = () => {
    if (!userToken) {
      router.push(`/users/login?callbackUrl=${encodeURIComponent(pathname)}`);
    }
    updateFavoritList.mutate(
      { userToken, id: productId },
      { onSuccess: () => setSucessLabel(true) }
    );
  };
  useEffect(() => {
    const timeId = setTimeout(() => {
      setSucessLabel(false);
    }, 3000);
    return () => {
      clearTimeout(timeId);
    };
  }, [sucessLabel]);

  return (
    <>
      <div className="absolute top-11  bg-light-gray-100 py-3 px-2 rounded-tl-md rounded-bl-md right-0 md:right-4 z-10">
        {video && (
          <div className="mt-4  first:mt-0">
            <ScrollToSection sectionId="spVideos">
              <Video />
            </ScrollToSection>
          </div>
        )}

        <div className="mt-4  first:mt-0 relative">
          <button
            className="text-light-blue text-sm flex "
            onClick={addProductToFavoritList}
            aria-label="add wishlist"
          >
            <Heart fill="#292D32" />
          </button>
          {sucessLabel && (
            <div className="absolute right-8 top-0 text-xs bg-black text-white whitespace-nowrap p-1 rounded-md">
              محصول به لیست شما افزوده شد
            </div>
          )}
        </div>
        {catalog && (
          <div className="mt-4 first:mt-0">
            <ScrollToSection sectionId="spCatalogs">
              <SmallPdf />
            </ScrollToSection>
          </div>
        )}
        {compare && (
          <div className="mt-4  first:mt-0 relative">
            <ScrollToSection sectionId="spCompareProduct">
              <Compare />
            </ScrollToSection>
          </div>
        )}
      </div>
    </>
  );
}
